import { V2L3TodoList } from "@fusion-advantage/formrender"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { selectDashboardDisplayIdentity } from "../../../redux/dashboardDataSlice"
import { UserRole } from "@fusion-advantage/backcompat"
import { DashboardLoadStatus, DashboardSelectionType, StatusedTodo, statusedWorkItemKey, WorkItemType } from "@fusion-advantage/formlib"
import { useCallback } from "react"
import { apiAuditAssign } from "../../../redux/apithunk/apiAudit"
import { setDashboardSelection } from "../../../redux/dashboardControlSlice"
import { appSync } from "../../../redux/syncthunk/syncThunk"
import { SyncType } from "../../../redux/syncthunk/SyncConfig"
import { selectDashboardListLoading, selectOpIsBlockingEncounterMgmt } from "../../../redux/selectDashboardLoading"

export const LxTodoList = () => {
	const loading = useAppSelector(selectDashboardListLoading)
	const opIsBlockingEncounterMgmt = useAppSelector(selectOpIsBlockingEncounterMgmt)
	const itemsState = useAppSelector(state => state.dashboardData.workItems[WorkItemType.Todo])
	const displayIdentity = useAppSelector(state => selectDashboardDisplayIdentity(state))
	const selection = useAppSelector(state => state.dashboardControl.selection)
	const dispatch = useAppDispatch()
	const handleItemClick = useCallback((item: DashboardSelectionType.TodaySummary|StatusedTodo) => {
		if(item === DashboardSelectionType.TodaySummary) {
			dispatch(setDashboardSelection({
				type: DashboardSelectionType.TodaySummary,
			}))
		} else {
			dispatch(setDashboardSelection({
				type: DashboardSelectionType.WorkItem,
				key: statusedWorkItemKey(item)
			}))
		}
	}, [dispatch])
	const handleRetrieveAuditClick = useCallback(async () => {
		if(opIsBlockingEncounterMgmt) {
			alert('A sync is currently in progress; please try again when complete.')
			return
		}
		const r = await dispatch(apiAuditAssign())
		if(r.isErr()) {
			// error message already displayed,
			// nothing further to do
			return
		}
		if(!r.value) {
			alert('There are no more audits in the queue at this time.')
			return
		}
		dispatch(appSync({
			type: SyncType.Dashboard,
		}))
	}, [opIsBlockingEncounterMgmt, dispatch])
	return (
		<V2L3TodoList
			status={loading ? DashboardLoadStatus.Loading : itemsState.status}
			items={itemsState.items ?? []}
			selection={selection}
			onItemClick={handleItemClick}
			isAuditor={Boolean(displayIdentity?.roles.includes(UserRole.AUDITOR))}
			onRetrieveAuditClick={handleRetrieveAuditClick}
		/>
	)
}
